import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"enable-background":"new 0 0 16 16"},
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-1007"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "m14.957 7.85-1.464-1.449c-.123-.122-.333-.036-.333.136v.881h-2.883a9.575 9.575 0 0 1-2.551-.64C6.57 6.315 4.87 5.631 5.145 4.355c.279-1.298 2.246-1.793 3.519-1.331.937.328 1.129 1.074 1.274 1.486.09.254.276.366.455.366h1.386c.267 0 .509-.253.452-.517-.128-.593-.48-1.588-1.438-2.361-1.231-.995-3.955-1.46-6.033-.103-.351.23-.82.641-1.213 1.305-1.252 2.118.644 4.063.76 4.219H1.716a.698.698 0 0 0-.701.695c0 .384.314.695.701.695 0 0 4.583-.185 6.096 0 .768.093 1.422.368 1.838.652 1.243.848 1.973 3.31-.587 3.72-.666.107-1.235.043-1.718-.121-1.205-.412-2.131-1.879-2.265-2.18-.017-.038-.075-.18-.218-.262-.122-.07-.247-.064-.301-.062-.258.011-.684.012-1.241.012a.415.415 0 0 0-.393.543c.285.892 1.174 2.571 2.869 3.421 1.8.902 4.336.625 5.799-.782a3.861 3.861 0 0 0 1.087-1.808c.048-.184.338-1.36-.248-2.583a3.664 3.664 0 0 0-.327-.551h1.053v.628c0 .172.211.259.334.137l1.464-1.449a.194.194 0 0 0-.001-.274z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }